import { Actions } from "./actions";
import { State } from "./state";
import { fromServer } from "../filters";
import initial from "./state.initial";

type TActions =
  | Actions.GetRequest
  | Actions.PostRequest
  | Actions.GetResponse
  | Actions.PostResponse
  | Actions.SyncRequest
  | Actions.SyncResponse;

const unixReducer = (
  state: State.Props = initial,
  action: TActions
): State.Props => {
  switch (action.type) {
    case Actions.REQUEST_POST:
      return { ...state, loadingPost: true };
      break;
    case Actions.REQUEST_GET:
      return { ...state, loadingGet: true };
      break;
    case Actions.REQUEST_SYNC:
      return { ...state, loadingPost: true };
      break;
    case Actions.RESPONSE_GET:
      return {
        ...state,
        status: "OK",
        data: fromServer(action.data),
        form: fromServer(action.data),
        submitRequired: false,
        loadingGet: false
      };
      break;
    case Actions.RESPONSE_POST:
      return { ...state, loadingPost: false };
      break;
    case Actions.RESPONSE_SYNC:
      return { ...state, loadingPost: false };
      break;
    default:
      return state;
  }
};

export default unixReducer;
